var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st430{fill:#FFFFFF;}\n\t.st429{fill:#FFFFFF;stroke:#000000;stroke-width:3.43;stroke-miterlimit:10;}\n\t.st428{fill:#FFFFFF;stroke:#000000;stroke-width:1.14;stroke-miterlimit:10;}\n\t.st427{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.5;}\n\t.st426{fill:#FFFFFF;stroke:#010101;stroke-width:3.09;stroke-miterlimit:10;}\n\t.st425{fill:none;stroke:#000000;stroke-width:3.43;stroke-miterlimit:10;}\n\t.st424{fill:none;}\n\t.st423{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st422{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.54,1.54;}\n\t.st421{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.55,1.55;}\n\t.st420{fill:#FFFFFF;stroke:#000000;stroke-width:1.17;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205.1,
    y: 326,
    className: "st430",
    width: 154.4,
    height: 27.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M62.4,353.3c0.7-9.5,1.5-37.5,2.5-47.3c2.3-23.8,5.3-45.4,8.3-64.5c0.2-1.5,0.5-3,0.7-4.5 c2.5-15.7,5.1-29.5,7.4-41v-0.1c8,2.1,18.7,4.6,31.5,6.7c2.9,0.5,10.2,1.7,20.6,2.9l-0.2,9.2l10.7,0.2l0.2-8.4 c4.2,0.4,8.8,0.7,13.7,1c1.5,0.1,3,0.2,4.6,0.2l4,0.2c14.4,0.6,27.5,0.3,38.5,0.1c2-0.1,4-0.1,6.1-0.2v26.8 c-0.1,39.7-0.3,79.4-0.5,119.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M211,207.7v0.2l-0.1,14.7v0.3c0,3.9,0,7.8-0.1,11.7v-26.9L211,207.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M211.4,333.4L211.4,333.4c0.9,0,1.8,0.1,2.7,0.1c14,0.1,25.8-10.6,27.1-24.5V208c5.6,0,11.4-0.1,17.4-0.3 l4.5-0.2c5.5-0.2,11.1-0.6,17-1.1l0.2,8.4l10.7-0.2l-0.2-9.2c6.6-0.8,13.5-1.7,20.7-2.9c11.7-2,21.7-4.2,29.2-6.1 c2.5,12.4,5.2,27.4,7.9,44.6c0.2,1.5,0.5,3,0.7,4.5c2.8,17.9,5.4,38.1,7.6,60.1c1.6,16.5,2.9,32.4,3.7,47.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M241.2,208V309c-1.4,13.9-13.1,24.6-27.1,24.5c-0.9,0-1.8-0.1-2.7-0.2c-0.1-36.8-0.2-73.6-0.4-110.5v-0.4 c0-4.9,0-9.8-0.1-14.8v-0.1h1.2c2.6,0.1,5,0.1,7.2,0.1C226.2,208,233.5,208.1,241.2,208z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st428",
    d: "M241.2,208V309c-1.4,13.9-13.1,24.6-27.1,24.5c-0.9,0-1.8-0.1-2.7-0.2l-0.5,0V207.7h1.2c2.6,0.1,5,0.1,7.2,0.1 C226.2,208,233.5,208.1,241.2,208z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st427",
    d: "M214,332c-0.5,0-1.1,0-1.6-0.1V209.2c2.5,0.1,4.8,0.1,7,0.1c6.2,0.1,12.4,0.2,18.8,0.2h1.6v99.3 C238.5,322.1,227.3,332.1,214,332z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st426",
    d: "M134.1,175.2l-0.5,22l-0.2,8c-10.4-1.2-17.8-2.4-20.6-2.9c-12.8-2.1-23.5-4.6-31.5-6.7l-1.6-0.4 c2.6-9.1,5.1-18.1,7.5-27.2L134.1,175.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st426",
    d: "M210.9,207.7L210.9,207.7c-2.1,0.1-4.1,0.1-6,0.2c-11,0.2-24.1,0.4-38.5-0.1l-4-0.2c-1.6-0.1-3.1-0.1-4.6-0.2 c-4.8-0.3-9.4-0.6-13.7-1l0.2-8.3l0.4-21.2l2.6,0.4c11.6,1.3,23.2,1.8,34.8,1.7c-1,7.2-1.2,14.5-0.7,21.7c0.1,1.9,0.3,3.8,0.5,5.6 C193.1,207.1,202.8,207.5,210.9,207.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st426",
    d: "M212.1,207.7h-1.2v-0.1h0.1L212.1,207.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st426",
    d: "M241.7,178.9c-10-0.1-19.9-0.6-29.6-1.1c10-0.5,19.9-1.2,29.5-1.5C241.7,177.1,241.7,178,241.7,178.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st426",
    d: "M280.1,206.4c-5.9,0.5-11.5,0.9-17,1.1l-4.5,0.2c-6,0.2-11.9,0.3-17.4,0.3c-7.7,0-15-0.1-21.8-0.2 c-2.2,0-4.6-0.1-7.2-0.1h-1.2c-8.1-0.2-17.8-0.6-28.9-1.4c-0.2-1.9-0.4-3.7-0.5-5.6c-0.5-7.3-0.3-14.5,0.7-21.7 c0.1-0.9,0.3-1.7,0.4-2.6c9.6,0.3,19.5,0.9,29.5,1.5l0,0c9.7,0.5,19.5,1,29.6,1.1c11.7,0.2,23.5-0.4,35.2-1.7l2.6-0.4l0.5,20.8 L280.1,206.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st426",
    d: "M344.6,195.4l-3.9,1c-7.5,1.9-17.5,4.1-29.2,6.1c-7.1,1.2-14,2.1-20.7,2.9l-0.2-8.5l-0.5-21.6l46.9-7.1 C339.5,177.2,342,186.2,344.6,195.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st425",
    x1: 292.4,
    y1: 205.3,
    x2: 357.3,
    y2: 310.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st424",
    x1: 288.4,
    y1: 204.4,
    x2: 359.5,
    y2: 319.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st423",
    x1: 288.4,
    y1: 204.4,
    x2: 288.8,
    y2: 205.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st422",
    x1: 289.6,
    y1: 206.4,
    x2: 358.7,
    y2: 318.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st423",
    x1: 359.1,
    y1: 319.3,
    x2: 359.5,
    y2: 319.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st424",
    x1: 137.8,
    y1: 202.9,
    x2: 63.7,
    y2: 317.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st423",
    x1: 137.8,
    y1: 202.9,
    x2: 137.4,
    y2: 203.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st421",
    x1: 136.6,
    y1: 204.8,
    x2: 64.6,
    y2: 315.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st423",
    x1: 64.1,
    y1: 316.5,
    x2: 63.7,
    y2: 317.1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st425",
    x1: 132.1,
    y1: 205.1,
    x2: 64.5,
    y2: 310.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st420",
    points: "291,214.6 280.3,214.8 280.1,206 279.9,196.7 279.5,174.9 279.4,172.7 290.1,172.4 290.1,173.2  290.6,195.9 290.8,204.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st420",
    points: "144.8,172.7 144.8,175 144.3,197.2 144.1,205.9 144,214.7 133.3,214.5 133.5,204.8 133.7,196.4  134.1,173.3 134.2,172.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHook);
export default __webpack_public_path__ + "static/media/HOOK.8338f2f84005b7d2e0fe501d53edaaa7.svg";
export { ForwardRef as ReactComponent };